import { Text } from '@wartek-id/text-v1'

import { formatDate, isDateValid } from 'utils/datetime'

export type CardNotificationBaseProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode
  date: string
  description: string
  title: string
}
const CardNotificationBase = ({
  children,
  date,
  description,
  title,
  ...divProps
}: CardNotificationBaseProps) => {
  return (
    <div className="p-6 space-y-2 bg-white rounded shadow" {...divProps}>
      <Text as="time" variant="helper" className="!text-disabled mb-3 block">
        {isDateValid(date) ? formatDate(date, 'dd MMMM yyyy') : '-'}
      </Text>
      <div className="space-y-1">
        <Text as="h3" variant="heading-sm">
          {title}
        </Text>
        <Text>{description}</Text>
      </div>
      <div>{children}</div>
    </div>
  )
}

export default CardNotificationBase
